import React from 'react'
import { StyledSlider as S } from './Slider.styles'
import { LEFT_SIDE_SLIDES, RIGHT_SIDE_SLIDES } from './constants'

export const Slider: React.FC = () => {
  return (
    <S.AnimationsContainer>
      <S.SliderContainer>
        <S.SlideList>
          {LEFT_SIDE_SLIDES.map(({ id, image }) => (
            <li key={id}>
              <S.Image src={image} alt="slide" />
            </li>
          ))}
        </S.SlideList>

        <S.SlideList>
          {LEFT_SIDE_SLIDES.map(({ id, image }) => (
            <li key={id}>
              <S.Image src={image} alt="slide" />
            </li>
          ))}
        </S.SlideList>
      </S.SliderContainer>

      <S.SliderContainer>
        <S.SlideList hasReverse>
          {RIGHT_SIDE_SLIDES.map(({ id, image }) => (
            <li key={id}>
              <S.Image src={image} alt="slide" />
            </li>
          ))}
        </S.SlideList>

        <S.SlideList hasReverse>
          {RIGHT_SIDE_SLIDES.map(({ id, image }) => (
            <li key={id}>
              <S.Image src={image} alt="slide" />
            </li>
          ))}
        </S.SlideList>
      </S.SliderContainer>
      <S.Shadow />
    </S.AnimationsContainer>
  )
}
